import q from "react";
import { clsx as z } from "../../../clsx/dist/clsx.js";
import { filterProps as B } from "../util/ReactUtils.js";
import { polarToCartesian as x, RADIAN as C } from "../util/PolarUtils.js";
import { getPercentValue as F, mathSign as N } from "../util/DataUtils.js";
function m(a) {
  "@babel/helpers - typeof";
  return m = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
    return typeof n;
  } : function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, m(a);
}
function O() {
  return O = Object.assign ? Object.assign.bind() : function(a) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (a[r] = t[r]);
    }
    return a;
  }, O.apply(this, arguments);
}
function D(a, n) {
  var t = Object.keys(a);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(a);
    n && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(a, o).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function L(a) {
  for (var n = 1; n < arguments.length; n++) {
    var t = arguments[n] != null ? arguments[n] : {};
    n % 2 ? D(Object(t), !0).forEach(function(r) {
      G(a, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(t)) : D(Object(t)).forEach(function(r) {
      Object.defineProperty(a, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return a;
}
function G(a, n, t) {
  return n = H(n), n in a ? Object.defineProperty(a, n, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : a[n] = t, a;
}
function H(a) {
  var n = J(a, "string");
  return m(n) == "symbol" ? n : n + "";
}
function J(a, n) {
  if (m(a) != "object" || !a) return a;
  var t = a[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(a, n);
    if (m(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (n === "string" ? String : Number)(a);
}
var Q = function(n, t) {
  var r = N(t - n), o = Math.min(Math.abs(t - n), 359.999);
  return r * o;
}, R = function(n) {
  var t = n.cx, r = n.cy, o = n.radius, i = n.angle, e = n.sign, p = n.isExternal, l = n.cornerRadius, u = n.cornerIsExternal, s = l * (p ? 1 : -1) + o, c = Math.asin(l / s) / C, g = u ? i : i + e * c, d = x(t, r, s, g), y = x(t, r, o, g), f = u ? i - e * c : i, v = x(t, r, s * Math.cos(c * C), f);
  return {
    center: d,
    circleTangency: y,
    lineTangency: v,
    theta: c
  };
}, Z = function(n) {
  var t = n.cx, r = n.cy, o = n.innerRadius, i = n.outerRadius, e = n.startAngle, p = n.endAngle, l = Q(e, p), u = e + l, s = x(t, r, i, e), c = x(t, r, i, u), g = "M ".concat(s.x, ",").concat(s.y, `
    A `).concat(i, ",").concat(i, `,0,
    `).concat(+(Math.abs(l) > 180), ",").concat(+(e > u), `,
    `).concat(c.x, ",").concat(c.y, `
  `);
  if (o > 0) {
    var d = x(t, r, o, e), y = x(t, r, o, u);
    g += "L ".concat(y.x, ",").concat(y.y, `
            A `).concat(o, ",").concat(o, `,0,
            `).concat(+(Math.abs(l) > 180), ",").concat(+(e <= u), `,
            `).concat(d.x, ",").concat(d.y, " Z");
  } else
    g += "L ".concat(t, ",").concat(r, " Z");
  return g;
}, U = function(n) {
  var t = n.cx, r = n.cy, o = n.innerRadius, i = n.outerRadius, e = n.cornerRadius, p = n.forceCornerRadius, l = n.cornerIsExternal, u = n.startAngle, s = n.endAngle, c = N(s - u), g = R({
    cx: t,
    cy: r,
    radius: i,
    angle: u,
    sign: c,
    cornerRadius: e,
    cornerIsExternal: l
  }), d = g.circleTangency, y = g.lineTangency, f = g.theta, v = R({
    cx: t,
    cy: r,
    radius: i,
    angle: s,
    sign: -c,
    cornerRadius: e,
    cornerIsExternal: l
  }), E = v.circleTangency, P = v.lineTangency, K = v.theta, S = l ? Math.abs(u - s) : Math.abs(u - s) - f - K;
  if (S < 0)
    return p ? "M ".concat(y.x, ",").concat(y.y, `
        a`).concat(e, ",").concat(e, ",0,0,1,").concat(e * 2, `,0
        a`).concat(e, ",").concat(e, ",0,0,1,").concat(-e * 2, `,0
      `) : Z({
      cx: t,
      cy: r,
      innerRadius: o,
      outerRadius: i,
      startAngle: u,
      endAngle: s
    });
  var b = "M ".concat(y.x, ",").concat(y.y, `
    A`).concat(e, ",").concat(e, ",0,0,").concat(+(c < 0), ",").concat(d.x, ",").concat(d.y, `
    A`).concat(i, ",").concat(i, ",0,").concat(+(S > 180), ",").concat(+(c < 0), ",").concat(E.x, ",").concat(E.y, `
    A`).concat(e, ",").concat(e, ",0,0,").concat(+(c < 0), ",").concat(P.x, ",").concat(P.y, `
  `);
  if (o > 0) {
    var h = R({
      cx: t,
      cy: r,
      radius: o,
      angle: u,
      sign: c,
      isExternal: !0,
      cornerRadius: e,
      cornerIsExternal: l
    }), j = h.circleTangency, M = h.lineTangency, W = h.theta, A = R({
      cx: t,
      cy: r,
      radius: o,
      angle: s,
      sign: -c,
      isExternal: !0,
      cornerRadius: e,
      cornerIsExternal: l
    }), T = A.circleTangency, I = A.lineTangency, V = A.theta, w = l ? Math.abs(u - s) : Math.abs(u - s) - W - V;
    if (w < 0 && e === 0)
      return "".concat(b, "L").concat(t, ",").concat(r, "Z");
    b += "L".concat(I.x, ",").concat(I.y, `
      A`).concat(e, ",").concat(e, ",0,0,").concat(+(c < 0), ",").concat(T.x, ",").concat(T.y, `
      A`).concat(o, ",").concat(o, ",0,").concat(+(w > 180), ",").concat(+(c > 0), ",").concat(j.x, ",").concat(j.y, `
      A`).concat(e, ",").concat(e, ",0,0,").concat(+(c < 0), ",").concat(M.x, ",").concat(M.y, "Z");
  } else
    b += "L".concat(t, ",").concat(r, "Z");
  return b;
}, X = {
  cx: 0,
  cy: 0,
  innerRadius: 0,
  outerRadius: 0,
  startAngle: 0,
  endAngle: 0,
  cornerRadius: 0,
  forceCornerRadius: !1,
  cornerIsExternal: !1
}, tn = function(n) {
  var t = L(L({}, X), n), r = t.cx, o = t.cy, i = t.innerRadius, e = t.outerRadius, p = t.cornerRadius, l = t.forceCornerRadius, u = t.cornerIsExternal, s = t.startAngle, c = t.endAngle, g = t.className;
  if (e < i || s === c)
    return null;
  var d = z("recharts-sector", g), y = e - i, f = F(p, y, 0, !0), v;
  return f > 0 && Math.abs(s - c) < 360 ? v = U({
    cx: r,
    cy: o,
    innerRadius: i,
    outerRadius: e,
    cornerRadius: Math.min(f, y / 2),
    forceCornerRadius: l,
    cornerIsExternal: u,
    startAngle: s,
    endAngle: c
  }) : v = Z({
    cx: r,
    cy: o,
    innerRadius: i,
    outerRadius: e,
    startAngle: s,
    endAngle: c
  }), /* @__PURE__ */ q.createElement("path", O({}, B(t, !0), {
    className: d,
    d: v,
    role: "img"
  }));
};
export {
  tn as Sector
};
